import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../store/actions";
import checkPermissions from "../../shared/checkPermissions";
import checkPermissionsActions from "../../shared/checkPermissionsActions";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import RSheetsAllList, { RS_VIEW_FILTERS_MODULE, RS_COLUMNS_META } from "../../containers/RSheets/RSheetsAllList";
import { ViewFiltersButton } from "../../components/ViewFiltersModal/useViewFilters";
import RSheetsTypeOptions from "../../containers/RSheets/RSheetsTypeOptions";
import RSheetsForm from "../../containers/RSheets/RSheetsForm";
import { doAction } from "../../containers/RSheets/RSheetsLogic";
import NotificationAsk from "components/Notification/NotificationAsk";
import Button from "../../components/CustomButtons/Button";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { getParameterByName, handleError } from "../../shared/utility";
import axios from "store/axios/axios-rs";
import { getUser } from "../../shared/authValidation";

const getAdminData = (args) => {
    const { 
        permsArr, 
        setLevel, 
        setAllLevels, 
        tab,
        getRsheets
    } = args;
    let highestLevel = 0;
    if (permsArr) {
        const levels = permsArr.filter(f => {
            if (f.indexOf('approve') !== -1) {
                return true;
            }
        }).map(m => {
            const mp = m.split('_level_')[1];
            return parseInt(mp);
        })
        console.log('levels', levels, permsArr);
        const maxLevel = Math.max(...levels);
        setLevel(maxLevel);
        setAllLevels(levels);
        // DB status
        const pendingObj = {
            1: [2,6], // submitted for level 1 approver's approval, level 2 denied back to level 1
            2: [
                2,6,
                3,7
            ], // submitted for level 2 approver's approval, 
            3: [
                2,6,
                3,7,
                4,8
            ], // submitted for level 3 approver's approval
            4: [
                2,6,
                3,7,
                4,8,
                10
            ], // submitted for level 4 final approver's appro
        }
        const furtherApprovalObj = {
            1: [3,4,10],
            2: [4,10],
            3: [10],
            4: []
        }
        let all_the_status = [];
        if (levels) {
            levels.forEach(pa => {
                const arrs = pendingObj[pa];
                console.log('pending arrs', pendingObj, pa);
                if (arrs) {
                    arrs.forEach(arrsa => {
                        if (all_the_status.indexOf(arrsa) === -1) {
                            all_the_status.push(arrsa);
                        }
                    })
                }
            })
        }
        // 1 - Draft 
        // 2 - Submitted to level 1 
        // 3 - Submitted to level 2
        // 4 - Submitted to level 3 
        // 5 - Level 1 Denied to Submitter = 2 -> 5
        // 6 - Level 2 Denied to Level 1 = 3 ->  6
        // 7 - Level 3 Denied to Level 2 = 4 -> 7
        // 8 - Final Approver denied to Level 3 = 10 -> 8
        // 9 - Final Approver approved
        // 10 - Submitted to final approver for approval 
        let the_status = pendingObj[maxLevel];
        if (tab === 'pending_further_approval') {
            the_status = furtherApprovalObj[maxLevel];
            all_the_status = [];
            if (levels) {
                levels.forEach(pa => {
                    const arrs = furtherApprovalObj[pa];
                    if (arrs) {
                        arrs.forEach(arrsa => {
                            if (all_the_status.indexOf(arrsa) === -1) {
                                all_the_status.push(arrsa);
                            }
                        })
                    }
                })
            }
        }
        console.log('doing Action', {tab, getRsheets, status:the_status})
        doAction({tab, getRsheets, status:the_status, all_the_status});
    }
}

class RSheetsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tab: "all",
            subFilter: "all",
            error: null,
            success: null,
            addSheet: false,
            currentType: null,
            showForm: true,
            currentAction: 'Add',
            level: null,
            allLevels: null,
            deleteData: null,
            askBeforeDelete: false,
            shouldReload: false,
            prefill_property_id: null,
            hiddenColumns: []
        };
    }

    setLevel = (level) => {
        this.setState({level});
    };

    setAllLevels = (allLevels) => {
        this.setState({allLevels});
    };

    setTab = (tab) => {
        this.setState({ tab });
    };

    setAddSheet = (addSheet) => {
        this.setState({ addSheet });
    }

    clearMessages = (callback) => {
        this.setState({ error: null, success: null }, () => {
            if (callback) {
                callback();
            }
        });
    };

    historyPush = (url) => {
        this.props.history.push(url);
    }

    loadRS = async (rs_id, options = {}) => {
        	// 0: 'Voided',
            // 1: 'Draft',
            // 2: 'Submitted to level 1',
            // 3: 'Submitted to level 2',
            // 4: 'Submitted to level 3',
            // 5: 'Level 1 Denied to Submitter',
            // 6: 'Level 2 Denied to Level 1',
            // 7: 'Level 3 Denied to Level 2',
            // 8: 'Final Approver denied to Level 3',
            // 9: 'Final Approver approved',
            // 10: 'Submitted to final approver for approval',
            // 11: 'Under internal review',
            // 12: 'Internal review - Approved', // used for history only
            // 13: 'Internal review - Denied' // used for history only
        try {
            const response = await axios.get('/rsheet?id='+rs_id);
            console.log('loading RS...', response.data);
            if (response.data) {
                const rs = response.data;
                this.props.getRsheet(rs.id);
                const user = getUser();
                let ownUser = false;
                if (user.id === rs.user_id) {
                    ownUser = true;
                }
                const forceView = Boolean(options.forceView);
                const stateObj = {
                    currentType: rs.type,
                    showForm: true,
                    currentAction: forceView ? 'View' : 'Edit',
                    viewOnly: forceView,
                };
                if (!forceView) {
                    if (rs.status === 1) {
                        if (ownUser) stateObj.currentAction = 'Edit'
                        if (!ownUser) {
                            stateObj.currentAction = 'View';
                            stateObj.viewOnly = true;
                        }
                    } else if (rs.status === 9) {
                        stateObj.currentAction = 'View';
                        stateObj.viewOnly = true;
                    }
                }
                this.setState(stateObj);
                const property_id = getParameterByName('return_to_property', window.location.href);
                console.log('href', window.location.href);
                if (property_id) {
                    window.history.replaceState(null, null, '/rs?return_to_property='+property_id);
                } else {
                    window.history.replaceState(null, null, '/rs');
                }
            }
        } catch(e) {
            handleError(e);
        }
    }

    componentDidMount() {
        this.goToAll();
        const directRsId = getParameterByName('id', window.location.href);
        const action = getParameterByName('p', window.location.href);
        const permitted = checkPermissions("Routing");
        if (directRsId && permitted) {
            this.loadRS(directRsId, { forceView: true });
            return;
        }
        if (action) {
            if (permitted) {
                const property_id = getParameterByName('property_id', window.location.href);
                if (property_id && action === 'new') {
                    const obj = {};
                    obj.addSheet = true;
                    obj.prefill_property_id = parseInt(property_id);
                    this.setState(obj);
                } else {
                    const rs_id = getParameterByName('rs_id', window.location.href);
                    if (rs_id) {
                        this.loadRS(rs_id);
                    }
                }
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.error !== this.props.error)
            this.setState({ error: this.props.error });
        if (prevProps.success !== this.props.success)
            this.setState({ success: this.props.success });
        if (prevProps.success_crud === null && this.props.success_crud) {
            if (this.state.shouldReload) {
                this.reload();
                this.setState({shouldReload:false});
            }
        }
    }

    reload = () => {
        const { getRsheets } = this.props;
        const { tab } = this.state;
        const permissions = checkPermissionsActions("Routing");
        const permsArr = permissions ? Object.keys(permissions) : [];
        // NOTE: not just admin anymore
        getAdminData({
            permsArr, 
            setLevel: this.setLevel, 
            setAllLevels: this.setAllLevels,
            tab,
            getRsheets
        });
    }

    goToMyDrafts = () => {
        this.setTab('my_drafts');
        const permissions = checkPermissionsActions("Routing");
        const permsArr = permissions ? Object.keys(permissions) : [];
        const setLevel = this.setLevel;
        const setAllLevels = this.setAllLevels;
        const { getRsheets } = this.props;
        getAdminData({
            permsArr,
            setLevel,
            setAllLevels,
            tab: 'my_drafts',
            getRsheets
        });
    }

    goToAll = () => {
        this.setState({ tab: 'all', subFilter: 'all' });
        const { getRsheets } = this.props;
        const permsObj = checkPermissionsActions("Routing") || {};
        const isApprover = Object.keys(permsObj).some(p => p.toLowerCase().indexOf('approve') !== -1);
        const levels = Object.keys(permsObj)
            .filter(p => p.indexOf('approve_level_') !== -1)
            .map(p => parseInt(p.split('_level_')[1]));
        if (levels.length > 0) {
            this.setLevel(Math.max(...levels));
            this.setAllLevels(levels);
        }
        if (isApprover) {
            getRsheets({ status: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] });
        } else {
            getRsheets({
                assoc_combined: true,
                open_statuses: [],
                own_statuses: [0, 1, 5, 9, 11]
            });
        }
    }

    choosePendingMyApproval = () => {
        const { getRsheets } = this.props;
        const permissions = checkPermissionsActions("Routing");
        const permsArr = permissions ? Object.keys(permissions) : [];
        const setLevel = this.setLevel;
        const setAllLevels = this.setAllLevels;
        this.setTab('pending_my_drafts');
        const obj = {
            permsArr, 
            setLevel, 
            setAllLevels,
            tab: 'pending_my_drafts',
            getRsheets
        };
        console.log('obj', obj);
        getAdminData(obj);
    }

    choosePendingFurtherApproval = () => {
        const { getRsheets } = this.props;
        const permissions = checkPermissionsActions("Routing");
        const permsArr = permissions ? Object.keys(permissions) : [];
        const setLevel = this.setLevel;
        const setAllLevels = this.setAllLevels;
        this.setTab('pending_further_approval');
        getAdminData({
            permsArr, 
            setLevel, 
            setAllLevels,
            tab: 'pending_further_approval',
            getRsheets
        });
    }

    chooseMyCompleted = () => {
        const { getRsheets } = this.props;
        const permissions = checkPermissionsActions("Routing");
        const permsArr = permissions ? Object.keys(permissions) : [];
        const setLevel = this.setLevel;
        const setAllLevels = this.setAllLevels;
        this.setTab('my_completed');
        getAdminData({
            permsArr, 
            setLevel, 
            setAllLevels,
            tab: 'my_completed',
            getRsheets
        });
    }

    chooseAllCompleted = () => {
        const { getRsheets } = this.props;
        const permissions = checkPermissionsActions("Routing");
        const permsArr = permissions ? Object.keys(permissions) : [];
        const setLevel = this.setLevel;
        const setAllLevels = this.setAllLevels;
        this.setTab('all_completed');
        getAdminData({
            permsArr, 
            setLevel, 
            setAllLevels,
            tab: 'all_completed',
            getRsheets
        });
    }

    chooseVoided = () => {
        const { getRsheets } = this.props;
        const permissions = checkPermissionsActions("Routing");
        const permsArr = permissions ? Object.keys(permissions) : [];
        const setLevel = this.setLevel;
        const setAllLevels = this.setAllLevels;
        this.setTab('voided');
        getAdminData({
            permsArr, 
            setLevel, 
            setAllLevels,
            tab: 'voided',
            getRsheets
        });
    }

    chooseMyVoided = () => {
        const { getRsheets } = this.props;
        const permissions = checkPermissionsActions("Routing");
        const permsArr = permissions ? Object.keys(permissions) : [];
        const setLevel = this.setLevel;
        const setAllLevels = this.setAllLevels;
        this.setTab('my_voided');
        getAdminData({
            permsArr, 
            setLevel, 
            setAllLevels,
            tab: 'my_voided',
            getRsheets
        });
    }

    render() {
        const permitted = checkPermissions("Routing");
        if (!permitted) {
            return <Redirect to="/dashboard" />;
        }

        const permissions = checkPermissionsActions("Routing");
        const permsArr = permissions ? Object.keys(permissions) : [];
        const isApprover = permissions
            ? JSON.stringify(permsArr).indexOf("approve") !== -1
                ? true
                : false
            : false;

        const { tab } = this.state;
        const { getRsheets } = this.props;

        console.log('levels', this.state.level, this.state.allLevels);

        console.log('RSheetsPage', this.state);

        return (
            <div style={{ marginTop: 20 }}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="rose" icon>
                                <CardIcon
                                    key={'all'}
                                    color={tab === 'all' ? "success" : "rose"}
                                    onClick={this.goToAll}
                                    className="hovered"
                                >
                                    <strong>ALL</strong>
                                </CardIcon>
                                {
                                    permissions.fill_form && (
                                        <CardIcon
                                            key={'my_drafts'}
                                            color={
                                                tab === 'my_drafts'
                                                    ? "success"
                                                    : "rose"
                                            }
                                            onClick={() => {
                                                this.goToMyDrafts();
                                            }}
                                            className="hovered"
                                        >
                                            <strong>My Drafts</strong>
                                        </CardIcon>
                                    )
                                }
								{
									isApprover && (
                                        <CardIcon
                                            key={'user_drafts'}
                                            color={
                                                tab === 'user_drafts'
                                                    ? "success"
                                                    : "rose"
                                            }
                                            onClick={() => {
                                                this.setTab('user_drafts');
                                                doAction({
                                                    getRsheets,
                                                    tab: 'user_drafts'
                                                });
                                            }}
                                            className="hovered"
                                        >
                                            <strong>All Drafts</strong>
                                        </CardIcon>
                                    )
								}
								{
									(
                                        <CardIcon
                                            key={'pending_my_drafts'}
                                            color={
                                                tab === 'pending_my_drafts'
                                                    ? "success"
                                                    : "rose"
                                            }
                                            onClick={this.choosePendingMyApproval}
                                            className="hovered"
                                        >
                                            <strong>Pending My Approval</strong>
                                        </CardIcon>
                                    )
								}
                                <CardIcon
                                    key={'pending_further_approval'}
                                    color={
                                        tab === 'pending_further_approval'
                                            ? "success"
                                            : "rose"
                                    }
                                    onClick={this.choosePendingFurtherApproval}
                                    className="hovered"
                                >
                                    <strong>Pending Further Approval</strong>
                                </CardIcon>
								<CardIcon
									key={'my_completed'}
									color={
										tab === 'my_completed'
											? "success"
											: "rose"
									}
									onClick={this.chooseMyCompleted}
									className="hovered"
								>
									<strong>My Completed</strong>
								</CardIcon>
								{
									isApprover && (
                                        <CardIcon
                                            key={'all_completed'}
                                            color={
                                                tab === 'all_completed'
                                                    ? "success"
                                                    : "rose"
                                            }
                                            onClick={this.chooseAllCompleted}
                                            className="hovered"
                                        >
                                            <strong>All Completed</strong>
                                        </CardIcon>
                                    )
								}
                                {isApprover && <CardIcon
									key={'voided'}
									color={
										tab === 'voided'
											? "success"
											: "rose"
									}
									onClick={this.chooseVoided}
									className="hovered"
								>
									<strong>All Voided</strong>
								</CardIcon>}
                                <CardIcon
									key={'my_voided'}
									color={
										tab === 'my_voided'
											? "success"
											: "rose"
									}
									onClick={this.chooseMyVoided}
									className="hovered"
								>
									<strong>My Voided</strong>
								</CardIcon>
                            </CardHeader>
                            <CardBody>
                                {this.state.tab && <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <h3>Routing Sheets</h3>
                                        {(tab === 'user_drafts' || tab === 'my_drafts') && <Button
                                            color="rose"
                                            onClick={() => {
                                                this.setAddSheet(true);
                                            }}
                                        >ADD NEW</Button>}
                                    </GridItem>
                                </GridContainer>}

                                {this.state.tab === 'all' && <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12, marginTop: 10, marginBottom: 10 }}>
                                    <div style={{ maxWidth: 360, flex: '0 0 360px' }}>
                                        <CustomSelect
                                            label="Filter"
                                            default={this.state.subFilter || 'all'}
                                            options={[
                                                { value: 'all', desc: 'All' },
                                                { value: 'my_drafts', desc: 'My Drafts' },
                                                { value: 'user_drafts', desc: 'All Drafts' },
                                                { value: 'pending_my_drafts', desc: 'Pending My Approval' },
                                                { value: 'pending_further_approval', desc: 'Pending Further Approval' },
                                                { value: 'my_completed', desc: 'My Completed' },
                                                { value: 'all_completed', desc: 'All Completed' },
                                                { value: 'voided', desc: 'All Voided' },
                                                { value: 'my_voided', desc: 'My Voided' }
                                            ]}
                                            choose={(val) => {
                                                this.setState({ subFilter: val });
                                            }}
                                            indx="value"
                                            desc="desc"
                                        />
                                    </div>
                                    <ViewFiltersButton
                                        moduleName={RS_VIEW_FILTERS_MODULE}
                                        columns={RS_COLUMNS_META}
                                        tab={this.state.subFilter || 'all'}
                                        onHiddenChange={(h) => this.setState({ hiddenColumns: h })}
                                    />
                                </div>}
                                {this.state.tab !== 'all' && <div style={{ marginTop: 10, marginBottom: 10 }}>
                                    <ViewFiltersButton
                                        moduleName={RS_VIEW_FILTERS_MODULE}
                                        columns={RS_COLUMNS_META}
                                        tab={this.state.tab}
                                        onHiddenChange={(h) => this.setState({ hiddenColumns: h })}
                                    />
                                </div>}

                                {this.state.tab && <RSheetsAllList
                                    list={this.props.rsheetsData}
                                    tab={this.state.tab}
                                    subFilter={this.state.subFilter}
                                    hiddenColumns={this.state.hiddenColumns}
                                    setTab={this.setTab}
                                    getRsheet={this.props.getRsheet}
                                    createRsheetRevision={this.props.createRsheetRevision}
                                    createRsHistory={this.props.createRsHistory}
                                    rsheetRevision={this.props.rsheetRevision}
                                    goToMyDrafts={this.goToMyDrafts}
                                    setViewOnly={(viewOnly) => { this.setState({viewOnly}) }}
                                    setShowForm={(showForm) => { this.setState({showForm}) }}
                                    setCurrentAction={() => { this.setState({currentAction: 'Edit'}) }}
                                    setAskBeforeDelete={(deleteData) => { this.setState({
                                        askBeforeDelete: true,
                                        deleteData
                                    })}}
                                    setCurrentType={(currentType) => { this.setState({currentType})}}
                                    loadingEntries={this.props.loadingEntries}
                                    getRsInternalReviewers={this.props.getRsInternalReviewers}
                                />}

                                {/* Ask which Routing Sheet Type to Add */}
                                {this.state.addSheet && <RSheetsTypeOptions 
                                    open={this.state.addSheet}
                                    close={() => { this.setAddSheet(false) }}
                                    addNewSheet={(currentType) => {
                                        this.setState({
                                            currentType,
                                            showForm: true,
                                            currentAction: 'Add',
                                            viewOnly: false,
                                        });
                                    }}
                                />}

                                {this.state.showForm && <RSheetsForm 
                                    currentType={this.state.currentType}
                                    action={this.state.currentAction}
                                    setShowForm={(showForm) => { 
                                        this.setState({showForm}) 
                                    }}
                                    showForm={this.state.showForm}
                                    tab={this.state.tab}
                                    viewOnly={this.state.viewOnly}
                                    getAdminData={(tab) => {
                                        if (tab === 'pending_my_drafts') {
                                            this.choosePendingMyApproval();
                                        } else if (tab === 'pending_further_approval') {
                                            this.choosePendingFurtherApproval();
                                        } else if (tab === 'my_completed') {
                                            this.chooseMyCompleted();
                                        } else if (tab === 'all_completed') {
                                            this.chooseAllCompleted();
                                        } else if (tab === 'voided') {
                                            this.chooseVoided();
                                        }
                                    }}
                                    level={this.state.level}
                                    historyPush={this.historyPush}
                                    prefill_property_id={this.state.prefill_property_id}
                                    reset_prefill_property_id={() => {
                                        this.setState({
                                            prefill_property_id: null
                                        });
                                    }}
                                    booga={true}
                                />}

                                {this.state.askBeforeDelete && <NotificationAsk 
                                    open={this.state.askBeforeDelete}
                                    close={() => {
                                        this.setState({askBeforeDelete:false});
                                    }}
                                    success={() => {
                                        if (this.state.deleteData) {
                                            this.setState({shouldReload:true});
                                            this.props.deleteRsheet({
                                                id: this.state.deleteData.id
                                            });
                                        }
                                        this.setState({askBeforeDelete:false});
                                    }}
                                    title="Are You Sure?"
                                    message="Do you want to delete this routing sheet ?"
                                />}

                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        error: state.rs.error,
        success: state.rs.success,
        success_crud: state.rs.success_crud,
        loading: state.rs.loading,
        loadingEntries: state.rs.loadingEntries,
        rsTypes: state.rs.rsTypes,
        rsheetsData: state.rs.rsheetsData,
        rsheetRevision: state.rs.rsheetRevision
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRoutingSheetType: () => dispatch(actions.getRsTypes()),
        getRsheets: (data) => dispatch(actions.getRsheets(data)),
        getRsheet: (id) => dispatch(actions.getRsheet(id)),
        updateRsheet: (params) => dispatch(actions.updateRsheet(params)),
        createRsheetRevision: (data) => dispatch(actions.createRsheetRevision(data)),
        deleteRsheet: (data) => dispatch(actions.deleteRsheet(data)),
        createRsHistory: (data) => dispatch(actions.createRsHistory(data)),
        getRsInternalReviewers: (data) => {
            dispatch(actions.getRsInternalReviewers(data));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RSheetsPage);
